import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useMemo } from "react";

import { fetchFieldOptions } from "../slices/fieldOptionsSlice";

export const useGetVehiclesEditOptions = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const rawFieldList = useSelector((state) => state.vehiclesEditFields.categories);
    const formValues = useSelector((state) => state.form.forms["vehiclesEditForm"]?.values || {});
    const loadingStatus = useSelector((state) => state.fieldOptions.loadingStatus);
    const loadedOptions = useSelector((state) => state.fieldOptions.options);

    const allFields = useMemo(() => {
        return Array.isArray(rawFieldList)
            ? rawFieldList.flatMap((category) => category.fields)
            : [];
    }, [rawFieldList]);

    useEffect(() => {
        if (!token || !allFields.length) return;

        allFields.forEach((field) => {
            const fieldName = field.name;
            const baseUrl = field.options;

            if (typeof baseUrl !== "string") return;

            const parentField = field.parameters?.filter_by_field;
            const parentValue = parentField ? formValues[parentField] : null;

            const alreadyLoaded = Array.isArray(loadedOptions[fieldName]);

            const isLoading = loadingStatus[fieldName];
            const canFetch =
                !isLoading &&
                !alreadyLoaded &&
                (parentField ? !!parentValue : true);

            if (!canFetch) return;

            let url = baseUrl;
            if (parentField && parentValue) {
                const separator = url.includes("?") ? "&" : "?";
                url += `${separator}${parentField}=${parentValue}`;
            }

            dispatch(fetchFieldOptions({ fieldName, url, token }));
        });
    }, [token, allFields, formValues, loadingStatus, loadedOptions, dispatch]);
};